import React from 'react';
import style from './E2HMI.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function E2HMI(props) {

  //check whether to render webp or png
  let imageType = "png"
  if (props.webp === "webp") {
    imageType = "webp"
  }

  return (
    <div className={style.E2HMI}>
      <Head>
        <title>E2HMI | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a>E&#178; Engineering Services</a></Link></li>
        <span>/</span>
        <li><Link href={'/e2-engineering-services/turnkey-installation-upgrades'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> Turnkey Installation Upgrades</a></Link></li>
        <span>/</span>
      </div>
      <h3>E2HMI</h3>
      <p>Basler Services&#39; engineers will custom design a Human Machine Interface, or HMI, to provide complete operator functionality specific to your system. Basler Services provides all devices, software and materials required for the installation, interconnection and testing of the E2HMI and associated devices.</p>
      <p>
        <img alt="technical support grid" src={'/Assets/Images/HMI_Screen_1.' + imageType}/>
        <img alt="technical support grid" src={'/Assets/Images/HMI_Screen_2.' + imageType}/>
      </p>
      <p>The user friendly, interactive touchscreens provide a single point of contact for real-time monitoring and control of the DECS systems including:</p>
      <div>
        <ul>
          <li>Full control of the DECS-450 System (AVR/FCR regulator transfer, setpoint raise/lower, etc.).</li>
          <li>Full monitoring of the DECS-450 operating parameters (generator 3-phase volts, generator frequency, generator 3-phase amps, bus volts, bus frequency, watts, vars, field amps and volts, generator breaker status, excitation mode status, mode tracking error, AVR/FCR/VAR/PF control setpoints, etc.).</li>
          <li>Full monitoring of the DECS-450 alarm and status functions (field overvoltage, field overcurrent, generator overvoltage, generator undervoltage, overexcitation limit, underexcitation limit, volts/hertz limit, setpoint upper limit, setpoint lower limit, failed-to-build generator voltage, loss of excitation, loss of voltage sensing, failed field isolation transducer, failed IFM-150 module, bridge overtemperature, regulator trip, exciter on/off, regulator in AVR/FCR control, PSS on/off, PSS enabled/disabled, etc.).</li>
          <li>Full monitoring of the unit MW/Mvar operating point within the generator capability curve displays.</li>
          <li>Optional upgrades including password protection, generator simulation, with Modbus and Ethernet communication interfaces and function specific audio alarms.</li>
        </ul>
      </div>
      <Link href={"/contact-us"}><a className={`${style.cta} ${style.primaryCta}`}>Contact Us <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
    </div>
  );
}

export default E2HMI;